import { defineMessages } from "react-intl";

const messages = defineMessages({
    retry: {
        id: "error.retry",
    },
});

export default messages;
